import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=4d744745&scoped=true&"
import script from "./BaseDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseDialog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=4d744745&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d744745",
  null
  
)

export default component.exports